var React = require('react');

function AddMediumThick (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M14 11h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5v5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-5H6a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 6 11h5V6a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5z"}));
}

AddMediumThick.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = AddMediumThick;

AddMediumThick.default = AddMediumThick;
